import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'

import { hydrateApp } from './components/hydrate.js'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

class AppElement extends BaseElement {
  name = tag

  render() {
    hydrateApp(this, this.preloadedState)

    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
